import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { parseIso8601String } from "@interface48/formatting";
import { createStyles, Theme, withStyles, WithStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import classNames from "classnames";
import React from "react";
import { EntryTypeLabelAndClassName } from "../../models";

const styles = (theme: Theme) =>
  createStyles({
    logEntry: {
      display: "flex",
      color: theme.palette.text.primary,
      marginBottom: "1rem",
    },
    logEntryType: {
      marginRight: "0.75rem",
    },
    logEntryTypeIconContainer: {
      backgroundColor: theme.palette.grey[500],
      color: theme.palette.common.white,
      width: "2rem",
      height: "2rem",
      lineHeight: "1.875rem",
      borderRadius: "1rem",
      textAlign: "center",
      cursor: "help",
    },
    logEntryComment: {
      // 	Sequences of whitespace will collapse into a single whitespace. Text will wrap when necessary,
      // and on line breaks
      whiteSpace: "pre-line",
    },
  });

interface AuditLogEntryFieldProps extends WithStyles<typeof styles> {
  entryTypeLabelAndClassName: EntryTypeLabelAndClassName;
  at: string;
  personName?: string | null;
  userName?: string | null;
  comment?: string | null;
  className?: string;
}

export const AuditLogEntryFieldComponent = (props: AuditLogEntryFieldProps) => {
  const { entryTypeLabelAndClassName, at, personName, userName, comment, className, classes } = props;

  const logDateTime = parseIso8601String(at);
  const by = personName ? (
    <span title={`On Account ${userName}`} style={{ cursor: "help" }}>
      {personName}
    </span>
  ) : (
    <span>{userName}</span>
  );

  return (
    <div className={classNames(classes.logEntry, className)}>
      <div className={classes.logEntryType}>
        <div
          title={entryTypeLabelAndClassName.label}
          className={classNames(classes.logEntryTypeIconContainer, entryTypeLabelAndClassName.iconClassName)}
        >
          <FontAwesomeIcon icon={["fas", entryTypeLabelAndClassName.faIconName]} />
        </div>
      </div>
      <div>
        <div>
          <Typography variant="body2">{by}</Typography>
          {logDateTime && (
            <Typography variant="caption" gutterBottom={true}>
              {logDateTime.date} {logDateTime.time}
            </Typography>
          )}
        </div>
        {comment && (
          <div className={classes.logEntryComment}>
            <Typography gutterBottom={true}>{comment}</Typography>
          </div>
        )}
      </div>
    </div>
  );
};

export const AuditLogEntryField = withStyles(styles)(AuditLogEntryFieldComponent);
